<template>
  <div>
    <div class="m-b-20 m-t-20 m-r-10" >
      <el-card class="box-card title" shadow="never">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <!-- 我收到的评价 -->
          <el-breadcrumb-item>{{$t('user_Index_WSDDPJ')}}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-card>      
    </div>
    <div class="border" style="width:99%;">
      <div class="clearfixed m-v-20">
        <div class="w-400 pull-left m-b-10">
          <div class="clearfixed">
            <!-- 综合评分 -->
            <p class="pull-left fs-14 lh-24 m-l-15">{{$t('user_Index_ZHPF')}}：</p> 
            <div class="progress-bar__outer w-200 pull-left m-l-5">
              <div class="progress-bar__inner" :style="barStyle"></div>
            </div>
            <p class="pull-left m-l-15 fs-14 lh-24">{{score}}{{$t('user_Index_F')}}</p>
          </div>
        </div>
        <div class="pull-left">
          <el-tag v-for="(tag,index) in comment" :key="index" size="medium" color='#f0f0f0' class="m-l-15">
            <span v-if="tag.content.length>10">{{tag.content.substr(1,10)+'...'}}</span>
            <span v-else>{{tag.content}}</span>
            <span v-if="tag.num>1">({{tag.num}})</span>
          </el-tag>
        </div>
      </div>  
      <el-table :data="tableData" style="width: 100%"  :header-cell-style="tableBG" highlight-current-row>
        <!-- 订单号 -->
          <el-table-column prop="orders_num" :label="$t('user_Index_DDH')">
            <template slot-scope="{ row }">
              <!-- <span class="cursor-pointer text-color-blue" @click="$router.push({path:'orderDetail',query:{id:row.order_id}})">{{row.orders_num}}</span> -->
              <router-link tag="a" class="text-blue" target="_blank" :to="{path:'orderManage/orderDetail',query:{id:row.order_id}}">{{row.orders_num}}</router-link>
            </template>
          </el-table-column>
          <!-- 验货时间 -->
          <el-table-column prop="inspect_time" :label="$t('user_Index_YHSJ')"></el-table-column>
          <!-- 产品名称 -->
          <el-table-column prop="products" :label="$t('user_Index_CPMC')">
            <template slot-scope="{ row }">
              <span>{{row.product_name.length&&row.product_name[0]?row.product_name.join(','):'N/A'}}</span>
            </template>
          </el-table-column>
          <!-- 验货城市 -->
          <el-table-column prop="city" :label="$t('user_Index_YHCS')"> </el-table-column>
          <!-- 来自客人的评价 -->
          <el-table-column :label="$t('user_Index_LZKRDPJ')">
            <template slot-scope="{ row }">
              <div style="max-height:150px;overflow-y:auto;">
                <div v-for="(item,index) in row.comments_user" :key="index" style="display:inherit" class="m-r-10">
                  
                    <span>
                      <div class="cursor-pointer m-b-10">
                          <span class="text-yellow m-r-10" v-if="item.score">{{item.score}}{{$t('user_Index_F')}}</span>
                          <el-popover
                            trigger="hover"
                            width="200"
                          >
                            <p>{{item.content}}</p>
                            <div style="text-align: right; margin: 0">
                              <!-- <el-button size="mini" type="text" @click="visible = false">取消</el-button> -->
                              <el-button type="primary" size="mini" @click="replay(row,item,1)">{{$t('user_Index_HF')}}</el-button>
                            </div>
                            <span slot="reference" class="overflow-1">{{item.content}}</span>
                          </el-popover>
                          <div v-for="(item1,index1) in item.child" :key="index1">
                            <span class="text-yellow m-r-10">{{replySceneObj[item1.reply_scene]}}{{$t('user_Index_HF')}}：</span>
                            <span class="m-r-10">{{item1.content}}</span>
                          </div>
                      </div>
                    </span>
                    <!-- <el-dropdown-menu slot="dropdown" v-if="item.score">
                      <el-dropdown-item @click.native="replay(row,item,1)">{{$t('user_Index_HF')}}</el-dropdown-item>
                    </el-dropdown-menu> -->
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 来自工厂的评价 -->
          <el-table-column :label="$t('user_Index_LZGCDPJ')">
            <template slot-scope="{ row }">
              <div style="max-height:150px;overflow-y:auto;">
                <div v-for="(item,index) in row.comments_factory" :key="index" class="m-r-10" style="display:inherit" >
                    <span>
                      <div class="cursor-pointer m-b-10">
                         <span class="text-yellow m-r-10" v-if="item.score">{{item.score}}{{$t('user_Index_F')}}</span>
                          <el-popover
                            trigger="hover"
                            width="200"
                          >
                            <p>{{item.content}}</p>
                            <div style="text-align: right; margin: 0">
                              <!-- <el-button size="mini" type="text" @click="visible = false">取消</el-button> -->
                              <el-button type="primary" size="mini" @click="replay(row,item,2)">{{$t('user_Index_HF')}}</el-button>
                            </div>
                            <span slot="reference" class="overflow-1">{{item.content}}</span>
                          </el-popover>
                          <div v-for="(item1,index1) in item.child" :key="index1">
                            <span class="text-yellow m-r-10">{{replySceneObj[item1.reply_scene]}}{{$t('user_Index_HF')}}：</span>
                            <span class="m-r-10">{{item1.content}}</span>
                          </div>
                      </div>
                    </span>
                    <!-- <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="replay(row,item,2)">{{$t('user_Index_HF')}}</el-dropdown-item>
                    </el-dropdown-menu> -->
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 来自验货在线员的评价 -->
          <el-table-column :label="$t('user_Index_LZHQYHYDPJ')">
            <template slot-scope="{ row }">
              <div style="max-height:150px;overflow-y:auto;">
                <div v-for="(item,index) in row.comments_admin" :key="index" class="m-r-10" style="display:inherit" >
                    <span>
                      <div class="cursor-pointer m-b-10">
                         <span class="text-yellow m-r-10" v-if="item.score">{{item.score}}{{$t('user_Index_F')}}</span>
                          <el-popover
                            trigger="hover"
                            width="200"
                          >
                            <p>{{item.content}}</p>
                            <div style="text-align: right; margin: 0">
                              <!-- <el-button size="mini" type="text" @click="visible = false">取消</el-button> -->
                              <el-button type="primary" size="mini" @click="replay(row,item,3)">{{$t('user_Index_HF')}}</el-button>
                            </div>
                            <span slot="reference" class="overflow-1">{{item.content}}</span>
                          </el-popover>
                          <div v-for="(item1,index1) in item.child" :key="index1">
                            <span class="text-yellow m-r-10">{{replySceneObj[item1.reply_scene]}}{{$t('user_Index_HF')}}：</span>
                            <span class="m-r-10">{{item1.content}}</span>
                          </div>
                      </div>
                    </span>
                    <!-- <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="replay(row,item,3)">{{$t('user_Index_HF')}}</el-dropdown-item>
                    </el-dropdown-menu> -->
                </div>
              </div>
            </template>
          </el-table-column>
      </el-table>
      <el-pagination v-if="page_total!=0" class="m-20 text-right" :page-size.sync="page_size" :page-sizes="page_size_opts" :total="page_total" layout="total, sizes, prev, pager, next, jumper" :current-page.sync="page_current" @current-change="pageChange" @size-change="pageSizeChange"></el-pagination>
    </div>
    <!-- 回复 -->
    <el-dialog v-dialogDrag :title="$t('user_Index_HF')" v-if="replayVis" :visible.sync="replayVis" width="300px">     
      <!-- 请输入回复内容 -->
      <el-input type="textarea" :rows="2" :placeholder="$t('user_Index_QSRHFNR')" v-model="form.content"></el-input>
      <div slot="footer" class="dialog-footer">
        <!-- 取消 确定 -->
        <el-button @click="replayVis=false" class="button-radius-5px">{{$t('user_Index_QX')}}</el-button>
        <el-button type="primary" class="button-radius-5px" @click="submissionReplay">{{$t('user_Index_QD')}}</el-button>
      </div>
    </el-dialog> 
  </div>
</template>

<script>
import { commentList,reply } from "@/Inspector_api/evaluation";
export default {
  data() {
    return {
      score:0,
      comment: [],
      tableData:[],
      replayVis:false,//回复弹窗
      replySceneObj:{
        1:this.$t('ty_YH'),
        2:this.$t('ty_YHY')
      },      
      form:{
        pid:'',//	评论id
        orders_id:'',//	订单id
        user_id:'',	//回复对象id
        content:'',//回复内容
        scene:4,//场景 1-用户回复 2-工厂回复 3-验货在线回复
      }
    };
  },
  methods: {
    
    //评价列表
    async getTableData(){      
      let list={
        page:this.page_current,
        page_size:this.page_size
      }
      const res = await commentList(list);
      const { code, data } = res.data;
      if (code == 200) {
        this.score= data.score?data.score:0;
        this.comment=data.comment?data.comment:[];
        this.tableData = data.data.data?data.data.data:[];
        this.page_total=data.data.total?data.data.total:0
      }
    },
    //回复
    replay(row,item,type){
      this.replayVis=true
      this.form={
        orders_id:row.order_id,//	订单id
        pid:item.id,//	评论id
        user_id:item.user_id,	//回复对象id
        content:'',//回复内容
        scene:type,//场景 1-用户回复 2-工厂回复 3-验货在线回复
      }
      // console.log(this.form)
    },
    //确定回复
    async submissionReplay(){
      if(this.form.content==''){
        this.$message.error(this.$t('user_Index_QSRHFNR'))
        return false
      }
      const res = await reply(this.form);
      const { code,msg } = res.data;
      if (code == 200) {
        this.$message.success(msg)
        this.getTableData()
        this.replayVis=false
      }else{
        this.$message.error(msg)
      }
    }

  },
  created() {
    this.getTableData()
  },
  computed:{
    barStyle() {
      const style = {};
      style.width = this.score*20 + '%';
      style.height = '24px';
      style.backgroundColor = "#f8ac6e";
      return style;
    }
  }
};
</script>


<style lang="scss" scoped>
.org {
  color: $--color-primary;
}
.progress-bar__outer{
  border: 1px solid #f8ac6e;
}
/deep/ .el-tag{
  border-color:#e6e6e6 ;
  color: #333333;
}
</style>